module.exports = __webpack_public_path__ + "img/3_31.078e4c9c.png";